import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            "availableCountryCodes": String
        }
    }

    static get targets() {
        return ["search", "companyName", "companyNameAlert", "addressLine1", "addressLine2", "city", "postcode", "country"];
    }

    async connect() {
        const { Address } = await import("imports/address");
        const address = new Address(
            [
                { element: this.searchTarget, field: "" },
                { element: this.companyNameTarget, field: "Company", mode: pca.fieldMode.POPULATE },
                { element: this.addressLine1Target, field: "Line1", mode: pca.fieldMode.POPULATE },
                { element: this.addressLine2Target, field: "Line2", mode: pca.fieldMode.POPULATE },
                { element: this.cityTarget, field: "City", mode: pca.fieldMode.POPULATE },
                { element: this.postcodeTarget, field: "PostalCode", mode: pca.fieldMode.POPULATE },
                { element: this.countryTarget, field: "CountryName", mode: pca.fieldMode.COUNTRY }
            ],
            {
                countries: { codesList: this.availableCountryCodesValue },
                setCountryByIP: false
            }
        );
        address.listen("populate", () => {
            this.companyNameAlertTarget.classList.add("d-none");
        });
    }

    populateAddressFromMyProfile() {
        this.companyNameTarget.value = this.companyNameTarget.dataset.profileValue;
        this.companyNameAlertTarget.classList.remove("d-none");
        this.addressLine1Target.value = this.addressLine1Target.dataset.profileValue;
        this.addressLine2Target.value = this.addressLine2Target.dataset.profileValue;
        this.cityTarget.value = this.cityTarget.dataset.profileValue;
        this.postcodeTarget.value = this.postcodeTarget.dataset.profileValue;
        this.countryTarget.value = this.countryTarget.dataset.profileValue;

        if (this.countryTarget.selectedIndex < 0) {
            this.countryTarget.selectedIndex = 0;
        }
    }
}

document.addEventListener(
    "keydown",
    e => {
        if (e.target.closest(".pca") && (e.code === "ArrowUp" || e.code === "ArrowDown")) {
            e.preventDefault();
        }
    }
);